// Register PWA service worker — `/sw.js` handles both Web Push and the
// offline-first cache layer added Feb 2026.
import { startPushNotifier } from "@/lib/pushNotifier";

export function registerServiceWorker() {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
    // Start the tab-hidden notification poller after the SW is registered
    // so `reg.showNotification` is available when we need it.
    try { startPushNotifier(); } catch (_e) { /* silent */ }
  });
}
